import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intl-pluralrules';

import React, { ComponentType } from 'react';

let renderer: any;
try {
  // eslint-disable-next-line global-require
  renderer = require(`./_render${Number(React.version.split('.')[0]) >= 18 ? '18' : '17'}`);
} finally {
  //
}

const render = <Props extends object, >(App: ComponentType<Props>, props?: Props) => {
  renderer.default(App, props);
};

export default render;
